<div class="settings-menu-btn"><button type="button" (click)="open()"><fa-icon [icon]="icons.faQuestionCircle"></fa-icon></button></div>